import Swal from "sweetalert2";

const helperSwal = ({ actionConfirm, actionCancel, isConfirmed }) => {
  if (isConfirmed && actionConfirm) {
    actionConfirm();
    return;
  }
  if (actionCancel) actionCancel();
};

/* --- ALERTA DE ERROR --- */
export function errorAlert({
  title = "Error",
  text = "Ha ocurrido un error inesperado",
  html = '',
  enmarked = false,
}) {
  const customClasses = {
    popup: "clase-swal",
    confirmButton: "button-swal-error",
  };

  if (enmarked) {
    customClasses.htmlContainer = "container-swal";
  }

  // Ya tiene el return
  return Swal.fire({
    target: document.getElementById('dashboard-content') || 'body',
    title: title,
    text: text,
    html: html,
    imageUrl: "/alerterror.png",
    confirmButtonText: "Aceptar",
    confirmButtonColor: "var(--primary, #3b82f6)",
    focusConfirm: false,
    width: 400,
    customClass: customClasses,
    imageAlt: "Error",
  });
}

/* --- ALERTA DE ÉXITO --- */
export function successAlert({
  title = "¡Éxito!",
  text = "La operación se realizó correctamente",
  confirm = "Cerrar",
  action,
  timer = null, // Agregado para que funcione el timer automático
}) {
  // 🎯 IMPORTANTE: Agregamos 'return' al inicio
  return Swal.fire({
    target: document.getElementById('dashboard-content') || 'body',
    timer: timer,
    timerProgressBar: timer ? true : false,
    title: title,
    text: text,
    imageUrl: "/alertsuccess.png",
    footer: "  ",
    confirmButtonText: confirm,
    confirmButtonColor: "var(--primary, #3b82f6)",
    focusConfirm: false,
    width: 400,
    customClass: {
      popup: "clase-swal-success",
      confirmButton: "button-swal-success",
      footer: "custom-footer-swal",
    },
    imageAlt: "Success",
  }).then((result) => {
    if (action) {
      helperSwal({
        isConfirmed: result.isConfirmed,
        actionConfirm: () => action(true),
        actionCancel: () => action(false),
      });
    }
    return result; // Retornamos el resultado para el componente
  });
}

/* --- ALERTA DE CANCELACIÓN --- */
export function cancelAlert({
  title = "Cancelado",
  text = "La operación ha sido cancelada",
  actionConfirm,
  actionCancel,
}) {
  // 🎯 IMPORTANTE: Agregamos 'return'
  return Swal.fire({
    target: document.getElementById('dashboard-content') || 'body',
    title: title,
    text: text,
    imageUrl: "/cancel.png",
    footer: "  ",
    confirmButtonText: "Cerrar",
    confirmButtonColor: "var(--primary, #3b82f6)",
    focusConfirm: false,
    width: 380,
    customClass: {
      popup: "clase-swal",
      confirmButton: "button-swal",
      footer: "custom-footer-swal",
    },
    imageAlt: "Canceled",
  }).then((result) => {
    helperSwal({ isConfirmed: result.isConfirmed, actionConfirm, actionCancel });
    return result;
  });
}

/* --- ALERTA DE MENSAJE --- */
export function messageAlert({ text = "Se ha enviado información a su correo" }) {
  // 🎯 IMPORTANTE: Agregamos 'return'
  return Swal.fire({
    target: document.getElementById('dashboard-content') || 'body',
    text: text,
    imageUrl: "/alertMessage.png",
    footer: "  ",
    confirmButtonText: "Cerrar",
    confirmButtonColor: "var(--primary, #3b82f6)",
    focusConfirm: false,
    width: 380,
    customClass: {
      popup: "clase-swal",
      confirmButton: "button-swal",
      footer: "custom-footer-swal",
    },
    imageAlt: "Message",
  });
}

/* --- GUARDAR CAMBIOS / ADVERTENCIA --- */
export function saveChanges({
  text = "¿Desea proceder con esta operación?",
  title = "Advertencia",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  action,
  showCancelButton = true,
}) {
  // 🎯 IMPORTANTE: Agregamos 'return'
  return Swal.fire({
    target: document.getElementById('dashboard-content') || 'body',
    title: title,
    html: `<div id="custom-text">${text}</div>`,
    imageUrl: "/warningMessage.png",
    footer: "  ",
    showCancelButton: showCancelButton,
    cancelButtonColor: "#6e7881",
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: "var(--primary, #3b82f6)",
    focusConfirm: false,
    width: 380,
    customClass: {
      popup: "clase-swal",
      cancelButton: "button-swal-cancel",
      confirmButton: "button-swal",
      footer: "custom-footer-swal",
    },
    imageAlt: "Warning",
    didOpen: () => {
      const buttonsContainer = document.querySeusuario(".swal2-actions");
      if (buttonsContainer) buttonsContainer.style.flexDirection = "row-reverse";
    },
  }).then((result) => {
    if (action) {
      helperSwal({
        isConfirmed: result.isConfirmed,
        actionConfirm: () => action(true),
        actionCancel: () => action(false),
      });
    }
    return result;
  });
}

/* --- ALERTA DE INFORMACIÓN --- */
export function infoAlert({ title, text }) {
  // 🎯 IMPORTANTE: Agregamos 'return'
  return Swal.fire({
    target: document.getElementById('dashboard-content') || 'body',
    text,
    title,
    confirmButtonText: "Cerrar",
    confirmButtonColor: "var(--primary, #3b82f6)",
    focusConfirm: false,
    width: 380,
    padding: "16px",
    customClass: {
      popup: "clase-swal",
      confirmButton: "button-swal",
      footer: "custom-footer-swal",
    },
  });
}

/* --- TOAST --- */
export const showToast = ({ title = "Transacción procesada!", icon = "success", timer = 3000 }) => {
  // 🎯 IMPORTANTE: Agregamos 'return'
  return Swal.fire({
    target: document.getElementById('dashboard-content') || 'body',
    toast: true,
    position: "top-end",
    icon: icon,
    title: title,
    showConfirmButton: false,
    timer,
  });
};